export * from './floating-actions.module';
export * from './floating-actions.component';
